<template>
    <div style="color: #333;">
        <el-tabs v-model="activeTab" :class="{ 'public-certificate-tabs': isPublicCertificateRoute }">
            <el-tab-pane v-if="showCertificatePane" label="Certificate" name="certificate">
                <el-button type="primary" :loading="downloading" @click="exportPDF('downloadCert')"
                    size="medium">Download
                    the
                    certificate</el-button>
                <div id="downloadCert">
                    <!-- v-if="projectInfo.project_code == '2025WEC'" -->
                    <ResponsiveCertificateFrame v-for="(item, index) in 1" :key="index"
                        :designWidth="1123" :designHeight="794">
                        <div class="certContainerWEC" data-certificate-document
                            data-export-width="1123" data-export-height="794">
                            <p class="tips">This certificate is proudly presented to</p>
                            <img :src="projectInfo.horizontal_advisor_cert" class="modelCert" crossorigin="anonymous" />
                            <div class="advisor">{{ advisor_name }}</div>
                            <div class="school">{{ accountInfo.account_nameEN }}</div>
                            <div class="date">{{ showCertDate }}</div>
                            <div class="tips1">{{ 'In recognition of your exceptional dedication and guidance as an adviser in the '}}</div>
                            <div class="project_name">{{ projectInfo.project_ename+'.' }}</div>

                            <div class="tips2">Your commitment to supporting and mentoring {{ mentoring_student_counts }} students has played an invaluable role in their preparation for this prestigious competition.</div>
                            <div class="tips3">Thank you for your hard work and dedication to fostering the spirit of excellence in academics!</div>

                            <div class="divider"></div>
                            <div class="show_date">{{ 'Date' }}</div>
                            <DigitalCertificateQr v-if="supportsDigitalCertificate" :url="advisorCertificateUrl"
                                :colorDark="advisorCertificateQrColor" class="certificate-qr" />
                        </div>
                    </ResponsiveCertificateFrame>
                </div>
            </el-tab-pane>


            <el-tab-pane v-if="showOutstandingAdviserPane" label="Outstanding Adviser" name="outstanding-adviser">
                <el-button type="primary" :loading="downloading" v-if="awardInfo && awardInfo !=null" @click="exportPDF('downloadAward')"
                    size="medium">Download
                    the
                    Award</el-button>
                    <p v-if="!awardInfo" style="margin-left: 20px;margin-top: 20px;">Although not awarded this time, your efforts are truly appreciated, and we look forward to your future impact!</p>
                <div id="downloadAward" v-if="awardInfo && awardInfo !=null">
                    <ResponsiveCertificateFrame v-for="(item, index) in 1" :key="index"
                        :designWidth="1123" :designHeight="794">
                        <div class="awardContainerWEC" data-certificate-document
                            data-export-width="1123" data-export-height="794">
                            <img :src="projectInfo.account_bronze_medal_cert" class="modelCert" crossorigin="anonymous" />
                            <div class="advisor">{{ advisor_name }}</div>
                            <div class="school">{{ accountInfo.account_nameEN }}</div>
                            <div class="tips">{{ 'is honored as the' }}</div>
                            <div class="award_label">{{ awardInfo.award_lable }}</div>
                            <div class="tips1">{{ 'for exceptional guidance and unwavering support to students in the  '}}</div>
                            <div class="project_name">{{projectInfo.project_ename+'.' }}</div>
                            <div class="tips2">{{'Thank you for your hard work and dedication to fostering the spirit of excellence in economics!'}}</div>
                            <div class="date">{{ showCertDate }}</div>
                            <div class="divider"></div>
                            <div class="show_date">{{ 'Date' }}</div>
                            <DigitalCertificateQr v-if="supportsDigitalCertificate" :url="outstandingAdviserUrl"
                                :colorDark="awardCertificateQrColor" class="certificate-qr" />
                        </div>
                    </ResponsiveCertificateFrame>
                </div>
            </el-tab-pane>

            <el-tab-pane v-if="showSchoolAwardPane" label="School Award" name="school-award">
                <el-button type="primary" :loading="downloading" v-if="schoolAwardInfo" @click="exportPDF('downloadSchoolAward')"
                    size="medium">Download the School Award</el-button>
                <p v-if="!schoolAwardInfo" style="margin-left: 20px;margin-top: 20px;">No school award has been issued for this event.</p>
                <div id="downloadSchoolAward" v-if="schoolAwardInfo">
                    <ResponsiveCertificateFrame :designWidth="1123" :designHeight="794">
                        <div class="schoolAwardContainerWEC" data-certificate-document
                            data-export-width="1123" data-export-height="794">
                            <img :src="projectInfo.account_bronze_medal_cert" class="modelCert" crossorigin="anonymous" />
                            <div class="school">{{ accountInfo.account_nameEN || accountInfo.account_name }}</div>
                            <div class="tips">is recognized with the</div>
                            <div class="award_label">{{ schoolAwardInfo.award_lable }}</div>
                            <div class="tips1">for outstanding academic performance in the</div>
                            <div class="project_name">{{ projectInfo.project_ename + '.' }}</div>
                            <div class="tips2">This distinction is based on the average score of the school's top six students.</div>
                            <div class="date">{{ showCertDate }}</div>
                            <div class="divider"></div>
                            <div class="show_date">Date</div>
                            <DigitalCertificateQr v-if="supportsDigitalCertificate" :url="schoolAwardUrl"
                                :colorDark="awardCertificateQrColor" class="certificate-qr" />
                        </div>
                    </ResponsiveCertificateFrame>
                </div>
            </el-tab-pane>

        </el-tabs>
    </div>
</template>

<script>
import { getAdvisorAwardsByApplication, getProjectManageByCode } from '../../api/eae'
import DigitalCertificateQr from '../../components/DigitalCertificateQr.vue'
import ResponsiveCertificateFrame from '../../components/ResponsiveCertificateFrame.vue'
import {
    DOWNLOAD_REQUIRES_EXTERNAL_BROWSER,
    downloadCertificateImages
} from '../../utils/certificateImage'
import {
    getUserId
} from '../../utils/store'
import {
    buildPublicAdvisorCertificateUrl,
    getCertificateDownloadPrefix,
    getDigitalCertificateConfig,
    isPublicAdvisorCertificatePath,
    supportsAdvisorDigitalCertificate
} from '../../config/digitalCertificates'
export default {
    name: 'index',
    components: {
        DigitalCertificateQr,
        ResponsiveCertificateFrame
    },
    data() {
        const allowedTabs = ['certificate', 'outstanding-adviser', 'school-award']
        const requestedTab = this.$route.query.tab
        return {
            activeTab: allowedTabs.includes(requestedTab) ? requestedTab : 'certificate',
            showCertDate: '',
            projectManager: {},
            id: this.$route.query.id,
            advisorId: this.$route.query.advisor_id || getUserId(),
            transcripts: [],
            projectInfo: {},
            advisorInfo: {},
            accountInfo: {},
            advisor_name :'',
            mentoring_student_counts: 0,
            awardInfo:null,
            schoolAwardInfo:null,
            downloading: false
        }
    },
    computed: {
        certificateConfig() {
            return getDigitalCertificateConfig(this.projectInfo && this.projectInfo.project_code)
        },
        isPublicCertificateRoute() {
            return isPublicAdvisorCertificatePath(this.$route.path)
        },
        showCertificatePane() {
            return !this.isPublicCertificateRoute || this.activeTab == 'certificate'
        },
        showOutstandingAdviserPane() {
            return !this.isPublicCertificateRoute || this.activeTab == 'outstanding-adviser'
        },
        showSchoolAwardPane() {
            return !this.isPublicCertificateRoute || this.activeTab == 'school-award'
        },
        supportsDigitalCertificate() {
            return supportsAdvisorDigitalCertificate(this.projectInfo && this.projectInfo.project_code)
        },
        advisorCertificateQrColor() {
            return (this.certificateConfig && this.certificateConfig.advisorCertificateQrColor) || '#E90046'
        },
        awardCertificateQrColor() {
            return (this.certificateConfig && this.certificateConfig.awardCertificateQrColor) || '#E90046'
        },
        advisorCertificateUrl() {
            return this.publicCertificateUrl('certificate')
        },
        outstandingAdviserUrl() {
            return this.publicCertificateUrl('outstanding-adviser')
        },
        schoolAwardUrl() {
            return this.publicCertificateUrl('school-award')
        }
    },
    mounted() {
        //测试使用
        // this.id = '66b38e54a4640bcf788b4570'
        this.fetchData()
    },
    methods: {

        async fetchData() {

            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading", 
                background: "rgba(0, 0, 0, 0.7)",
            });


            let awardsResult = await getAdvisorAwardsByApplication(this.id, this.advisorId)
            let result = awardsResult.data.data
            this.projectInfo = result.project_info
            this.advisorInfo = result.advisor_info
            this.accountInfo = result.account_info
            this.advisor_name = this.advisorInfo.contact_enName ? this.advisorInfo.contact_enName : this.advisorInfo.contact_givenName + ' ' + this.advisorInfo.contact_lastName
            this.mentoring_student_counts = result.mentoring_student_counts
            this.awardInfo = result.advisor_award
            this.schoolAwardInfo = result.school_award

            let projectManageResult = await getProjectManageByCode(this.projectInfo.project_code)
            this.projectManager = projectManageResult.data
            this.formatCertDate(this.projectManager.entry_date[0].cert_date)

            loading.close()
        },
        publicCertificateUrl(tab) {
            return buildPublicAdvisorCertificateUrl(
                this.projectInfo && this.projectInfo.project_code,
                this.id,
                tab,
                this.advisorId
            )
        },
     
        async exportPDF(id) {

            const downloadPrefix = supportsAdvisorDigitalCertificate(this.projectInfo.project_code)
                ? getCertificateDownloadPrefix(this.projectInfo.project_code)
                : null

            if (downloadPrefix) {
                const documentNames = {
                    downloadCert: 'Advisor_Certificate',
                    downloadAward: 'Outstanding_Adviser_Award',
                    downloadSchoolAward: 'School_Award'
                }
                const subjectName = id == 'downloadSchoolAward'
                    ? (this.accountInfo.account_nameEN || this.accountInfo.account_name)
                    : this.advisor_name

                this.downloading = true
                try {
                    await downloadCertificateImages(
                        id,
                        downloadPrefix + '_' + documentNames[id] + '_' + subjectName
                    )
                    this.$message.success('Certificate downloaded')
                } catch (error) {
                    console.error('Unable to download certificate image', error)
                    if (error && error.code === DOWNLOAD_REQUIRES_EXTERNAL_BROWSER) {
                        this.showOpenInBrowserMessage()
                    } else {
                        this.$message.error('Unable to download the image. Please try again.')
                    }
                } finally {
                    this.downloading = false
                }
                return
            }

            var style = document.createElement('style');
            if (id == 'downloadSchoolAward') {
                style.innerHTML = "@page{size:A4 landscape;margin: auto 0mm}";
            } else if (id == 'downloadAward' || id == 'downloadCert') {
                if (this.projectInfo.project_code == '2025WEC') {
                    style.innerHTML = "@page{size:A4 landscape;margin: auto 0mm}";
                } else {
                    style.innerHTML = "@page{size:A4 portrait;margin: auto 0mm}";
                    document.getElementsByTagName("body")[0].style.zoom = 1
                }
            } else {
                if (this.projectInfo.project_code == '2024AEO') {
                    style.innerHTML = "@page{size:A4 landscape;}";
                } else {
                    style.innerHTML = "@page{size:A4 portrait;margin: auto 0mm}";
                    document.getElementsByTagName("body")[0].style.zoom = 1
                }
            }


            window.document.head.appendChild(style)

            const printData = document.getElementById(id).innerHTML


            this.PageSetup_Null();//把页眉页脚设置为空


            window.document.body.innerHTML = printData // 把 html 里的数据 复制给 body 的 html 数据 ，相当于重置了 整个页面的 内容
            window.print() // 开始打印


            //   const printData = document.getElementById(id).innerHTML

            //   window.document.body.innerHTML = printData // 把 html 里的数据 复制给 body 的 html 数据 ，相当于重置了 整个页面的 内容
            //   window.print() // 开始打印
        },
        showOpenInBrowserMessage() {
            this.$alert(
                'Please open this page in Safari, Chrome, Edge, or another browser to download the image.',
                'Open in a browser',
                {
                    confirmButtonText: 'OK',
                    type: 'info'
                }
            ).catch(() => {})
        },
        PageSetup_Null() {
            var HKEY_Root, HKEY_Path, HKEY_Key;

            HKEY_Root = "HKEY_CURRENT_USER";

            HKEY_Path = "\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";

            try {
                var Wsh = new ActiveXObject("WScript.Shell");

                HKEY_Key = "header";

                Wsh.RegWrite(HKEY_Root + HKEY_Path + HKEY_Key, "");

                HKEY_Key = "footer";

                Wsh.RegWrite(HKEY_Root + HKEY_Path + HKEY_Key, "");

            } catch (e) { }

        },

        formatCertDate(mills) {
            var date = new Date(mills);
            let year = date.getFullYear();
            let day = date.getDate();
            let month = date.getMonth() + 1;
            this.showCertDate =
                this.formatMonthToEng(month) + " " + day + ", " + year;
        },

        formatMonthToEng(month) {
            switch (month) {
                case 1:
                    return "January";
                case 2:
                    return "February";
                case 3:
                    return "March";
                case 4:
                    return "April";
                case 5:
                    return "May";
                case 6:
                    return "June";
                case 7:
                    return "July";
                case 8:
                    return "August";
                case 9:
                    return "September";
                case 10:
                    return "October";
                case 11:
                    return "November";
                case 12:
                    return "December";
            }
        },
    }
}
</script>

<style lang="scss">
.public-certificate-tabs {
    > .el-tabs__header {
        display: none;
    }
}

@media (max-width: 767px) {
    .public-certificate-tabs {
        .el-button {
            width: 100%;
            min-height: 44px;
            margin-bottom: 10px;
        }
    }
}

.certContainerWEC {
    position: relative;
    width: 1123px;
    height: 794px;
    overflow: hidden;
    font-family: 'Lato', sans-serif;
    // font-family: 'Inter', sans-serif;

    .modelCert {
        display: block;
        width: 100%;
        height: 100%;
    }

    .tips {
        width: 297mm;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 295px;
        font-size: 15px;
        line-height: 24px;
        font-weight: 100;
    }

    .advisor {
        position: absolute;
        top: 325px;
        width: 297mm;
        font-size: 34px;
        font-weight: 700;
        text-align: center;
    }

    .school {
        width: 297mm;
        position: absolute;
        top: 375px;
        text-align: center;
        font-size: 24px;
        font-weight: 350;
    }


    .tips1 {
        width: 297mm;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 415px;
        font-size: 15px;
        line-height: 24px;
        font-weight: 100;
    }

    .project_name{
        width: 297mm;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 445px;
        font-size: 16px;
        line-height: 26px;
        font-weight: 100;
    }

    .tips2 {
        width: 297mm;
        padding: 0px 270px;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 480px;
        font-size: 15px;
        line-height: 24px;
        font-weight: 100;
    }

    .tips3 {
        width: 297mm;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 535px;
        font-size: 15px;
        line-height: 24px;
        font-weight: 100;
    }
    .date {
        text-align: center;
        width: 150px;
        position: absolute;
        top: 610px;
        left: 400px;
        font-size: 18px;
        font-weight: 400;
    }
 
    .divider{
        position: absolute;
        top: 640px;
        width: 150px;
        color: #000;
        left: 400px;
        font-size: 18px;
        font-weight: 400;
        border-bottom-color:#666666;
        border-bottom-width: 1px;

    }
    .show_date {
        position: absolute;
        top: 654px;
        left: 400px;
        width: 150px;
        text-align: center;
        font-size: 18px;
        font-weight: 400;
    }

    .certificate-qr {
        position: absolute;
        top: 570px;
        left: 650px;
    }
}


.awardContainerWEC {
    position: relative;
    width: 1123px;
    height: 794px;
    overflow: hidden;
    font-family: 'Lato', sans-serif;
    // font-family: 'Inter', sans-serif;

    .modelCert {
        display: block;
        width: 100%;
        height: 100%;
    }
    .advisor {
        position: absolute;
        top: 300px;
        width: 297mm;
        font-size: 34px;
        font-weight: 700;
        text-align: center;
    }

    .school {
        width: 297mm;
        position: absolute;
        top: 355px;
        text-align: center;
        font-size: 24px;
        font-weight: 350;
    }


    .tips {
        width: 297mm;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 395px;
        font-size: 15px;
        line-height: 24px;
        font-weight: 100;
    }

    .award_label{
        width: 297mm;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 430px;
        font-size: 22px;
        line-height: 26px;
        font-weight: 600;
    }

    .tips1 {
        width: 297mm;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 470px;
        font-size: 15px;
        line-height: 24px;
        font-weight: 100;
    }

    .project_name{
        width: 297mm;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 500px;
        font-size: 16px;
        line-height: 26px;
        font-weight: 100;
    }

    .tips2 {
        width: 297mm;
        text-align: center;
        box-sizing: border-box;
        position: absolute;
        top: 535px;
        font-size: 15px;
        line-height: 24px;
        font-weight: 100;
    }

    .date {
        text-align: center;
        width: 150px;
        position: absolute;
        top: 610px;
        left: 400px;
        font-size: 18px;
        font-weight: 400;
    }
 
    .divider{
        position: absolute;
        top: 640px;
        width: 150px;
        color: #000;
        left: 400px;
        font-size: 18px;
        font-weight: 400;
        border-bottom-color:#666666;
        border-bottom-width: 1px;

    }
    .show_date {
        position: absolute;
        top: 650px;
        left: 400px;
        width: 150px;
        text-align: center;
        font-size: 18px;
        font-weight: 400;
    }

    .certificate-qr {
        position: absolute;
        top: 570px;
        left: 650px;
    }
}

.schoolAwardContainerWEC {
    position: relative;
    width: 1123px;
    height: 794px;
    overflow: hidden;
    font-family: 'Lato', sans-serif;

    .modelCert {
        display: block;
        width: 100%;
        height: 100%;
    }

    .school {
        position: absolute;
        top: 315px;
        width: 297mm;
        padding: 0 100px;
        box-sizing: border-box;
        text-align: center;
        font-size: 34px;
        line-height: 42px;
        font-weight: 700;
    }

    .tips,
    .award_label,
    .tips1,
    .project_name,
    .tips2 {
        position: absolute;
        width: 297mm;
        box-sizing: border-box;
        text-align: center;
    }

    .tips {
        top: 395px;
        font-size: 15px;
    }

    .award_label {
        top: 430px;
        font-size: 24px;
        line-height: 28px;
        font-weight: 700;
    }

    .tips1 {
        top: 475px;
        font-size: 15px;
    }

    .project_name {
        top: 505px;
        font-size: 16px;
    }

    .tips2 {
        top: 540px;
        padding: 0 220px;
        font-size: 15px;
        line-height: 24px;
    }

    .date {
        position: absolute;
        top: 610px;
        left: 400px;
        width: 150px;
        text-align: center;
        font-size: 18px;
    }

    .divider {
        position: absolute;
        top: 640px;
        left: 400px;
        width: 150px;
        border-bottom: 1px solid #666666;
    }

    .show_date {
        position: absolute;
        top: 650px;
        left: 400px;
        width: 150px;
        text-align: center;
        font-size: 18px;
    }

    .certificate-qr {
        position: absolute;
        top: 570px;
        left: 650px;
    }
}
</style>
